import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/SystemLog/Table";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
    Bg,
    BoxContainer,
    Underline,
} from "../../Components/Styles/PageStyles";
import {
    FieldWrapper,
    InputGroup,
    Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";


const SystemLog = () => {
    const user = useSelector((state) => state.UserReducer.user);
    const [selectedData, setSelectedData] = useState("");
    const [fetchData, setFetchData] = useState([]);
    const [filterValue, setFilterValue] = useState("");
    const [filter, setFilter] = useState("1");
    const [type, setType] = useState(1);
    // const [startDate, setStartDate] = useState(
    //     moment(new Date()).subtract(360, "days").format("YYYY-MM-DD")
    // );
    const [startDate, setStartDate] = useState(
        moment(new Date()).format("YYYY-MM-DD") 
    );
    const [endDate, setEndDate] = useState(
        moment(new Date()).format("YYYY-MM-DD")
    );
    const { t, i18n } = useTranslation();

    const initialValues = {
        name: "",
        filterVal: filterValue,
        startDate: moment(new Date()).format("YYYY-MM-DD"),
        // endDate: moment(new Date()).format("YYYY-MM-DD"),
    };

    const fetchFunction = async () => {
        const body = new FormData();
        body.append("startDate", startDate);
        body.append("type", filter);
        return await axios.post(`${Config.apiUrl}/getlogs`, body, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        });
    };

    const getLogSuccess = (res) => {
        //console.log("res", fetchData);
        if (res.data.status == "NOK" || res.data.data == false) {
            error = true;
        } else setFetchData(res.data.logs);
    };


    const getLogError = (res) => { };

    const {
        isLoading: isLoading,
        mutate: getLogMutate,
        error,
        data,
        isRefetching,
        refetch,
    } = useMutation(fetchFunction, {
        onSuccess: getLogSuccess,
        onError: getLogError,
    });

    useEffect(() => {
        const handler = setTimeout(() => {
            getLogMutate();
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [filterValue, startDate, filter]);

    const submitHandler = (values) => {
        const newValues = {
            startDate: moment(values.startDate).format("YYYY-MM-DD"),
            // endDate: moment(values.endDate).format("YYYY-MM-DD"),
        };
        setStartDate(newValues.startDate);
        // setEndDate(newValues.endDate);
        getLogMutate();
    };
    const ChangeHandler = (e) => {
        setFilterValue(e.target.value);
    };

    return (
        <>
            <Bg
                style={{
                    backgroundImage: `url(${Images.BeamsBg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "top left",
                    height: "100vh",
                }}
            >
                <Navbar />

                {/* <Page> */}
                <BoxContainer>
                    <div className="flex w-full justify-between items-center">
                        <div>
                            <Title>{t("System Logs")}</Title>
                            <Underline />
                        </div>
                    </div>

                    <div className="flex w-full justify-between items-center">
                        <Filters
                            submitHandler={submitHandler}
                            initialValues={initialValues}
                            InitialLoading={isLoading}
                            setFilter={setFilter}
                            setFilterValue={setFilterValue}
                            ChangeHandler={ChangeHandler}
                            filterValue={filterValue}
                            filter={filter}
                            user={user}
                            t={t}
                        />
                    </div>

                    {!error && !isLoading && data && (
                        <TableWrapper>
                            <Table
                                logs={fetchData || []}
                            />
                            {(error || data?.data?.msg == "No data found") && !isLoading && (
                                <NotFoundModel />
                            )}
                        </TableWrapper>
                    )}
                    {(isLoading || isRefetching) && <Loading />}
                </BoxContainer>
            </Bg>
        </>
    );
};

const Filters = ({
    initialValues,
    submitHandler,
    InitialLoading,
    user,
    filter,
    setFilter,
    setFilterValue,
    filterValue,
    ChangeHandler,
    t,
}) => {
    const today = moment().format("YYYY-MM-DD");
    return (
        <Formik initialValues={initialValues} onSubmit={submitHandler}>
            <Form className="w-full">
                <FilterContainer>
                    <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
                        <div className="flex items-end gap-2">
                            <InputGroup className="max-w-[200px]">
                                <Label htmlFor="startDate">{("Date")}:</Label>
                                <FieldWrapper className="h-10">
                                    <img
                                        src={Images.Calender}
                                        alt="Calender icon"
                                        className="w-3.5"
                                    />
                                    <Field
                                        type="date"
                                        name="startDate"
                                        id="startDate"
                                        className="ml-1"
                                        max={today}
                                    />
                                </FieldWrapper>
                            </InputGroup>
                        </div>
                        <ApplyBtn disabled={InitialLoading} type="submit">
                            {t("Date_filter")}
                        </ApplyBtn>
                    </div>
                    <InputGroup
                        className="min-w-[120px]"
                        style={{ flexBasis: "content" }}
                    >
                        <Label htmlFor="filterVal">{("Log Type")}:</Label>
                        <Select
                            autoComplete="off"
                            className="w-25 px-2 bg-transparent text-sm border-none"
                            style={{ height: "40px" }}
                            value={filter}
                            onChange={(e) => {
                                setFilter(e.target.value);
                                setFilterValue("");
                            }}
                        >
                            <MenuItem value="2">Logs</MenuItem>
                            <MenuItem value="1">Error Logs</MenuItem>


                        </Select>
                    </InputGroup>

                </FilterContainer>
            </Form>
        </Formik>
    );
};

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
    p.$active
        ? "bg-gray-100"
        : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;

export default SystemLog;